import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '@/shared/components/ui/button/Button';

type MfaSetupProps = {
    moveNext: () => void;
};

export const MfaSetupTotp: React.FC<MfaSetupProps> = ({ moveNext }) => {
    const { user, setupMFA, mfaTotpQrCode, mfaTotpSecret } = useAuth();
    const [error, setError] = useState<string>('');
    const [codeSent, setCodeSent] = useState(false);
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (hasInitialized.current) return;

        const sendInitialCode = async () => {
            if (!codeSent) {
                try {
                    hasInitialized.current = true;
                    await setupMFA({ method: 'totp' });
                    setCodeSent(true);
                } catch {
                    setError('Failed to send verification code. Please try again.');
                    hasInitialized.current = false;
                }
            }
        };

        sendInitialCode();
    }, [setupMFA, codeSent]);

    return (
        <>
            <div className="flex flex-row">
                <div className="flex-grow p-4 space-y-4">
                    <p className="mt-2 text-sm text-mp-muted">
                        Scan the QR code below with your authenticator app on your phone.
                    </p>
                    <div>
                        {mfaTotpQrCode ? (
                            <img
                                src={mfaTotpQrCode}
                                alt="MFA QR Code"
                                className="p-1 border border-mp-border"
                            />
                        ) : (
                            <p className="text-sm text-mp-muted">Loading QR code…</p>
                        )}
                    </div>
                    <div className="mt-8 space-y-4">
                        <div className="relative">
                            <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-mp-border"></div>
                            </div>
                            <div className="relative flex justify-center text-sm">
                                <span className="px-2 bg-mp-surface text-mp-muted">
                                    If you can't use the QR code, enter this text code instead
                                </span>
                            </div>
                        </div>
                        <div className="mt-2 space-y-2">
                            <p className="text-sm text-mp-muted">
                                <span className="font-bold">Account Name:</span> {user?.email}
                            </p>
                            <p className="text-sm text-mp-muted">
                                <span className="font-bold">Secret Key:</span>{' '}
                                {mfaTotpSecret ? mfaTotpSecret : 'Loading Secret...'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {error && <p className="mt-6 text-sm text-mp-error text-center">{error}</p>}
            <div className="flex flex-row justify-end">
                <div className="w-full lg:w-1/3">
                    <Button
                        className="w-full"
                        onClick={() => {
                            moveNext();
                        }}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </>
    );
};
